import React, { useState, useEffect } from 'react';
import { getSeenByInitialsFallback, getPublicProfilePhotoUrl } from '../util/util';

function initialsBgStyle(userId) {
  let h = 0;
  const s = String(userId);
  for (let i = 0; i < s.length; i++) {
    h = s.charCodeAt(i) + ((h << 5) - h);
  }
  const hue = Math.abs(h) % 360;
  return { backgroundColor: `hsl(${hue} 38% 42%)`, color: '#fff' };
}

/**
 * Same resolution order as getProfilePhoto: uploaded file (public storage URL) first,
 * then users.picture (e.g. OAuth). No per-chip async fetch.
 */
function SeenByAvatarChip({ user, sizeClass, showRing }) {
  const initials = getSeenByInitialsFallback(user);
  const metaPic =
    user.picture != null && String(user.picture).trim() ? String(user.picture).trim() : null;
  const storagePic = user.id ? getPublicProfilePhotoUrl(user.id, 0) : null;

  const [tier, setTier] = useState(() => (storagePic ? 'storage' : metaPic ? 'meta' : null));
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setTier(storagePic ? 'storage' : metaPic ? 'meta' : null);
    setImgFailed(false);
  }, [user.id, storagePic, metaPic]);

  const src =
    tier === 'storage' ? storagePic : tier === 'meta' ? metaPic : null;

  const ringClass = showRing ? 'ring-2 ring-white' : '';

  return (
    <div
      className={`relative ${sizeClass} ${ringClass} rounded-full overflow-hidden shrink-0 flex items-center justify-center bg-gray-100`}
    >
      {src && !imgFailed ? (
        <img
          key={tier}
          src={src}
          alt=""
          className="h-full w-full object-cover"
          onError={() => {
            if (tier === 'storage' && metaPic) {
              setTier('meta');
            } else {
              setImgFailed(true);
            }
          }}
        />
      ) : (
        <div
          className="flex h-full w-full items-center justify-center text-sm font-oswald leading-none antialiased"
          style={initialsBgStyle(user.id)}
        >
          {initials}
        </div>
      )}
    </div>
  );
}

export default SeenByAvatarChip;
